<template>
  <div>
    <div class="row" style="margin-bottom: 1rem">
      <div class="col-sm-6 col-md-4 align-self-end" style="text-align: left">
        <h5>{{ $t('capas_grid.listado_capas')}} <span class="badge badge-primary">{{ this.countLayers }}</span></h5>
      </div>

      <div class="col-sm-6 offset-md-4 col-md-4 align-self-end" style="text-align: right">
        <input type="text" class="form-control2" style="width: 100%" v-model="searchText" :placeholder="$t('capas_grid.buscar_capa')" minlength="3">
      </div>
    </div>


    <div class="portfolio-filter capas row text-center" v-if="layers.length > 0">
      <ul>
        <li :class="{'sel-item':groupSelected == null}" @click="filterLayersByGroup(null)">Tot</li>
        <li v-for="group in groupsFirstLevel" :class="{'sel-item':groupSelected === group.id}" @click="filterLayersByGroup(group.id)" v-show="group.is_published == 1">
          {{ group[`title_${locale}`] }}
        </li>
      </ul>
    </div>

    <div class="portfolio-items mapas row" v-if="searchText !== '' && layersPaged.length === 0">
      <div class="col-12 text-center">
        <p>{{ $t('capas_grid.sin_resultados') }}</p>
      </div>
    </div>

    <div class="portfolio-items capas row fade-list">
        <LayerItem
                class="col-lg-4 col-sm-6"
                v-for="layer in layersPaged"
                v-if="layer.is_published == 1"
                :key="layer.code"
                :layer="layer"
        ></LayerItem>
    </div>

    <div class="row" v-if="totalPages > 1">
      <div class="col-12">
        <Paginator :total-pages="totalPages" :current-page.sync="currentPage"></Paginator>
      </div>
    </div>

  </div>
</template>

<script>
    import {LayersService} from "../../../commons/services/layersService";
    import LayerItem from "./LayerItem";
    import Paginator from "../Paginator";
    import MediaQueryMixin from '../../../commons/mixins/mediaQueryMixin';
    import {ArrayUtils} from "../../../commons/utils/arrayUtils";
    import {FiltersLayerUtils} from "../../../commons/utils/filtersLayerUtils";


    export default {
        name: 'LayersSection',
        components: {Paginator, LayerItem},
        mixins: [MediaQueryMixin],
        props: {
            langKey: {
                type: String,
                validator: value => ['es', 'ca'].indexOf(value) !== -1
            }
        },
        data() {
            return {
                groupSelected: null,
                loading: true,
                groups: [],
                layers: [],
                searchText: '',
                currentPage: 1,
                itemsPerPage: 6,
                totalPages: 0
            }
        },
        computed: {
            locale() {
                return this.$i18n.locale
            },
            groupsFirstLevel() {
                return this.groups.filter(group => group.parent_id === null)
            },
            layersFiltered() {
                let filteredLayersByGroup = this.layers;

                // if (this.groupSelected !== null)
                    filteredLayersByGroup = FiltersLayerUtils.filterLayersByGroupsIds([this.groupSelected], this.layers, this.groups);

                if (!this.searchText) return filteredLayersByGroup;

                return FiltersLayerUtils.filterLayersByText(this.searchText, filteredLayersByGroup, this.locale);
            },
            layersPaged() {
                this.totalPages = Math.ceil(this.layersFiltered.length / this.itemsPerPage);

                if (this.totalPages === 1) return this.layersFiltered;

                const start = (this.currentPage - 1) * this.itemsPerPage;
                let end = this.itemsPerPage * this.currentPage;
                if (end > this.layersFiltered.length) end = this.layersFiltered.length;

                return this.layersFiltered.slice(start, end);
            },
            countLayers() {
              let count = 0;
              this.layers.forEach((layer) => {
                if(layer.is_published == 1) count++;
              });
              return count;
            }
        },
        async mounted() {

            if (this.langKey) {
                this.$i18n.locale = this.langKey;
            }

            await this.loadInitialData();
            this.calcPageSize();
        },
        watch: {
            $mq: function () {
                this.calcPageSize();
            }
        },
        methods: {
            filterLayersByGroup(groupId) {
                this.groupSelected = groupId;
                this.currentPage = 1;
            },
            async loadInitialData() {
                this.loading = true;

                try {
                    this.layers = await LayersService.fetchLayers();
                    this.layers = ArrayUtils.orderByKey(this.layers, `title_${this.locale}`);

                    this.groups = await LayersService.fetchGroups();
                    this.groups = ArrayUtils.orderByKey(this.groups, `title_${this.locale}`);

                    this.loading = false;
                } catch (e) {
                    console.log(e);
                    this.loading = false;
                }
            },
            calcPageSize() {
                let newItemsPerPage = 0;

                if (this.$mq === 'xs') {
                    newItemsPerPage = 1;
                } else {
                    newItemsPerPage = 6;
                }

                if (this.itemsPerPage !== newItemsPerPage) {
                    this.itemsPerPage = newItemsPerPage;
                    this.currentPage = 1;
                }
            }
        }
    }
</script>
